import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import React, { useEffect, useState } from "react";

const ViewPatientStatementPopup = ({
  ViewPdf,
  onClose,
  Heading,
  disableDraggable,
}) => {
  const uniqueId = "ViewPatientStatementPopup";
  const [showPdf, setShowPdf] = useState(false);
  useEffect(() => {
    if (ViewPdf.type === "base64") {
      function base64ToBlob(base64, type = "application/octet-stream") {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: type });
      }

      const blob = base64ToBlob(ViewPdf.value, "application/pdf");
      const url = URL.createObjectURL(blob);
      setShowPdf(url);
    } else if (ViewPdf.type === "url") {
      setShowPdf(ViewPdf.value);
    } else {
      setShowPdf(ViewPdf.value ?? ViewPdf);
    }
  }, [ViewPdf]);
  return (
    <ReactPortal wrapperId={uniqueId}>
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable
          disableDraggable={disableDraggable}
          handle={`#${uniqueId}`}
        >
          <div
            data-te-modal-dialog-ref
            className="relative w-[1140px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            {/* Header */}
            <div
              id={uniqueId}
              className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
            >
              {Heading ? Heading : "View Patient Statement"}
              <button
                onClick={onClose}
                className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2"
              >
                <img src="/img/crossblack.svg" alt="cross" />
              </button>
            </div>

            <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
              {showPdf ? (
                <iframe
                  title="HCFA File"
                  style={{ border: "none" }}
                  src={`${showPdf}#toolbar=1&navpanes=1`}
                  height={500}
                  width="100%"
                  type="application/pdf"
                ></iframe>
              ) : showPdf ? (
                ""
              ) : (
                <span
                  style={{
                    fontSize: "17px",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "260px",
                  }}
                >
                  {/* File not found ! */}
                </span>
              )}
            </div>

            {/* Footer */}
            <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
              <CustomButtonNew
                label={"Cancel"}
                variant={"outline"}
                onClick={onClose}
              />
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default ViewPatientStatementPopup;
